// ----------------------------------------------------------------------------
// Snippet: Country Modal
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------
// Styles
import './_country-modal.scss';

/**
 * Country Modal Snippet Script
 * ------------------------------------------------------------------------------
 * A file that manage auto-redirect when the user first comes to the website.
 * There will be no auto-redirect for returning users.
 */

var inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

var removeLoadingClass = function() {
    if( document.body.classList.contains("geoip2-loading") ){
        document.body.classList.remove("geoip2-loading");
    }
};

var startCountryDetection = function() {
    if( document.body.classList.contains("country-redirect-auto") ){
        doLocale();
    } else {
        createCountryPopup();
    }
};

// Auto redirect
var doLocale = function() {

    var countryMap = {
        "earthrated.com": "US",
        "earthrated-global.myshopify.com": "US"
    };

    var global_hostnames = ["earthrated.com", "earthrated-global.myshopify.com"];
    var current_hostname = window.location.hostname;
    var simple_hostname = current_hostname.replace('www.', '');
    const window_url = new URL(window.location.href);

    // get the current market's subfolder
    var root_route = window.Shopify.routes.root;

    if (global_hostnames.includes(simple_hostname)) {
        if ( root_route == '/en-eu/' || root_route == '/fr-eu/' ) {
            var countryRedirect = "EU"
        } else if ( root_route == '/en-ca/' || root_route == '/fr-ca/' ) {
            var countryRedirect = "CA"
        } else if ( root_route == '/en-uk/' ) {
            var countryRedirect = "GB"
        } else {
            // Default to US
            var countryRedirect = "US"
        }
    } else {
        // Default to US
        var countryRedirect = "US"
    }

    var hostCountry = countryMap[location.hostname];

    // Default to US
    if (hostCountry === undefined) {
        var hostCountry = "US";
    }

    // Don't show the modal if If we are inside the customizer.
    if (inIframe()) {
        removeLoadingClass();
        return;
    }

    /**
     * Return Visitor!
     */

    var storedGeoCountry = localStorage.getItem("geoCountry");

    if (storedGeoCountry !== null) {
        // If it's a return visitor, don't redirect and remove the "geoip2-loading" class
        removeLoadingClass();

    } else if (typeof geoip2 === "undefined") {

    /**
     * Console error if GeoIP2 fails to load or is blocked for security
    */
        console.error("geoip2 is undefined");
        removeLoadingClass();
    } else {

        /**
         * Newbie user!
         */
        //GeoIP fetched successfully
        var geoSuccess = function (location) {
            var geoCountryCode = location.country.iso_code;
            var geoContinent   = location.continent.code;

            // Assign country to localStorage.
            localStorage.setItem("geoCountry", geoCountryCode);

            // CHECK! Does geo country match host country?
            if (geoCountryCode != "CA"
                && geoCountryCode != "US"
                && geoCountryCode != "GB"
                && geoContinent   != "EU") {
                // If a user is located outside of Canada, US, UK, Europe, then they should remain on the store they landed on
                removeLoadingClass();
            } else {
                // adding the custom parameter to the url without reloading after Shopify auto-redirect kicks in
                if (geoCountryCode != countryRedirect) {
                    window_url.searchParams.set('countryRedirect', countryRedirect);
                    window.history.replaceState(null, null, window_url);

                    removeLoadingClass();
                } else {
                    removeLoadingClass();
                }
            }
        };

        // GeoIP Failed, show error
        var geoError = function (err) {
            console.error(err);
            removeLoadingClass();
        };

        // Get location from geoip database
        geoip2.city(geoSuccess, geoError);
    }
};

// Country Switch Popup
var createCountryPopup = function() {

    var countryMap = {
        "earthrated.com": "US",
        "earthrated-global.myshopify.com": "US"
    };

    var global_hostnames = ["earthrated.com", "earthrated-global.myshopify.com"];
    var current_hostname = window.location.hostname;
    var simple_hostname = current_hostname.replace('www.', '');

    // get the current market's subfolder
    var root_route = window.Shopify.routes.root;

    if (global_hostnames.includes(simple_hostname)) {
        if ( root_route == '/en-eu/' || root_route == '/fr-eu/' ) {
            var countryRedirect = "EU"
        } else if ( root_route == '/en-ca/' || root_route == '/fr-ca/' ) {
            var countryRedirect = "CA"
        } else if ( root_route == '/en-uk/' ) {
            var countryRedirect = "GB"
        } else {
            var countryRedirect = "US"
        }
    } else {
        // Default to US
        var countryRedirect = "US"
    }

    var hostCountry = countryMap[location.hostname];

    // Default to US
    if (hostCountry === undefined) {
        var hostCountry = "US";
    }

    // Don't show the modal if If we are inside the customizer.
    if (inIframe()) {
        removeLoadingClass();
        return;
    }

    /**
     * Return Visitor!
     */

    var storedGeoCountry = localStorage.getItem("geoCountry");

    if (storedGeoCountry !== null) {
        // If it's a return visitor, don't redirect and remove the "geoip2-loading" class
        removeLoadingClass();

    } else if (typeof geoip2 === "undefined") {

    /**
     * Console error if GeoIP2 fails to load or is blocked for security
    */
        console.error("geoip2 is undefined");
        removeLoadingClass();
    } else {

    /**
     * Newbie user!
     */
        //GeoIP fetched successfully
        var geoSuccess = function (location) {
            var geoCountryCode = location.country.iso_code;
            var geoContinent   = location.continent.code;

            // Assign country to localStorage.
            localStorage.setItem("geoCountry", geoCountryCode);

            // CHECK! Does geo country match host country?
            if (geoCountryCode != "CA"
                && geoCountryCode != "US"
                && geoCountryCode != "GB"
                && geoContinent   != "EU") {
                // If a user is located outside of Canada, US, UK, Europe, then they should remain on the store they landed on
                removeLoadingClass();
            } else {
                //redirect to Global and they can select the preferred store
                if (geoCountryCode != countryRedirect) {
                    document.querySelector('#country-modal').classList.add('modal--open');
                    removeLoadingClass();
                } else {
                    removeLoadingClass();
                }
            }
        };

        // GeoIP Failed, show error
        var geoError = function (err) {
            console.error(err);
            removeLoadingClass();
        };

        // Get location from geoip database
        geoip2.city(geoSuccess, geoError);
    }

    $('#country-modal .country-popup__item, #country-modal .country-popup__button, #country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();

        var linkCountry = $(this).attr('data-country');
        localStorage.setItem('geoCountry', linkCountry);

        if (!$(e.currentTarget).hasClass('country-popup__item')) {
            $('#country-modal').removeClass('modal--open');
        } else {
            window.location = $(this).attr('href');
        }

    });

};

startCountryDetection();
